import React, { Fragment, useContext, useEffect, useState } from "react";
import { getTokenData } from "../../../../services/Auth__Service";
import { PARAMS_NUMBERS } from "../../../../services/config";
import { findOne } from "../../../../services/Salarie__Service";
import { allStatSalarie } from "../../../../services/Statistique__Service";
import navContext from "../../../Context/navContext";
import notifyContext from "../../../Context/notifyContext";
import Loader from "../../../Loader/Loader";
import NumericLabel from "react-pretty-numbers";
import { Link } from "react-router-dom";
import ListDocumentForOneSalarie from "../ListDocumentForOneSalarie/ListDocumentForOneSalarie";

const DashBoardMain = () => {
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const [stat, setStat] = useState({
    countDocument: 0,
    countDocumentArchivied: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [salarie, setSalarie] = useState(null);

  useEffect(() => {
    const data = getTokenData();
    nav({
      links: [
        {
          href: "/salarie/dashboard",
          linkname: "Accueil",
        },
      ],
      children: "",
    });
    fetchAllStatistique(data.user_id);
    fetchOneSalarie(data.user_id);
  }, []);

  const fetchAllStatistique = async (id) => {
    allStatSalarie(id)
      .then((response) => {
        setStat(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const fetchOneSalarie = async (id) => {
    findOne(id).then((response) => {
      setSalarie(response.data);
    });
  };

  return (
    <Fragment>
      <div className="dashboard main">
        <div className="dashboard__header">
          <div>
            <h3 className="dashboard__salutation">
              <p> Bienvenue {salarie !== null ? salarie.fullname : null}</p>
            </h3>
          </div>
          {/* <div className="simulation-stats">
            <p className="simulation-stats__title">Documents</p>
            <p>
              Disponible (s) :
              <strong>
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countDocument}
                </NumericLabel>
              </strong>
            </p>
            <p>
              Archivé (s) :{" "}
              <strong>
                {" "}
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countDocumentArchivied}
                </NumericLabel>
              </strong>
            </p>
          </div> */}
        </div>
        <div className="dashboard__body">
          <div className="dashboard__stats">
            <div className="stat">
              <h1 className="stat__count">
                <NumericLabel params={PARAMS_NUMBERS}>
                  {stat.countDocument}
                </NumericLabel>
              </h1>
              <h4 className="stat__title">Total Bulletins</h4>
              <Link className="stat__link" to="/salarie/document">
                Afficher
              </Link>
            </div>
          </div>
          <div className="dashboard__list">
            <ListDocumentForOneSalarie salarieId={salarie && salarie.id} />
          </div>
        </div>
      </div>
      {isLoading && <Loader loadingMsg="Chargement en cours" />}
    </Fragment>
  );
};

export default DashBoardMain;
